import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductTypesComponent } from '@src/app/features/product-types/product-types/product-types.component';
import { AddProductTypeComponent } from '@src/app/features/product-types/add-product-type/add-product-type.component';
import { ViewProductTypeComponent } from '@app/features/product-types/view-product-type/view-product-type.component';
import { EditProductTypeComponent } from '@src/app/features/product-types/edit-product-type/edit-product-type.component';

const routes: Routes = [
  { path: '', component: ProductTypesComponent },
  { path: 'add', component: AddProductTypeComponent },
  { path: ':productTypeId/edit', component: EditProductTypeComponent },
  { path: ':productTypeId', component: ViewProductTypeComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductTypeRoutingModule { }
